// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6657":"330ac24b","8580":"25523a73"}[chunkId] + ".chunk.css";
};